import {useAxios} from "@vueuse/integrations/useAxios";
import {IExam, IGetResult, ISubmitExamRequest} from "@/types/api.ts";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {AfterFetchContext} from "@vueuse/core";
import {API_URLS} from "@/utils/constants/api-urls.ts";

export class ExamService {

  static getInstance(): ExamService {
    return new ExamService();
  }

  async submitExam(body: ISubmitExamRequest): Promise<void> {
    const {execute, data} = useAxios<IGetResult>(API_URLS.exams.submit, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }

  viewGradesForCurrentStudent() {
    return useFactoryFetch(API_URLS.exams.gradesForCurrentUser, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.studentGrades}
      }
    }).json();
  }

  viewGradesForAllStudents() {
    return useFactoryFetch(API_URLS.exams.gradesForAllStudents, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.grades}
      }
    }).json();
  }

  async deleteExam(grade: IExam) {
    const {execute} = useAxios<IGetResult>(API_URLS.exams.deleteById(grade._id), {
      method: "DELETE",
    }, axiosInstance, {immediate: false})
    await execute();
  }
}